import styled from 'styled-components'
import { themeGet } from 'styled-system'
import BackLink from './component'

export const StyledBackLink = styled(BackLink)`
  color: ${themeGet('colors.darkGray')};
  font-size: 1rem;
  font-family: ${themeGet('font.molde.regular')};
  width: 100%;
`
